var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.80542 8.11111C8.80542 8.93623 9.1332 9.72755 9.71664 10.311C10.3001 10.8944 11.0914 11.2222 11.9165 11.2222C12.7416 11.2222 13.533 10.8944 14.1164 10.311C14.6999 9.72755 15.0276 8.93623 15.0276 8.11111C15.0276 7.28599 14.6999 6.49467 14.1164 5.91122C13.533 5.32778 12.7416 5 11.9165 5C11.0914 5 10.3001 5.32778 9.71664 5.91122C9.1332 6.49467 8.80542 7.28599 8.80542 8.11111Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24976 19.0006V17.4451C7.24976 16.62 7.57753 15.8287 8.16098 15.2452C8.74442 14.6618 9.53575 14.334 10.3609 14.334H13.472C14.2971 14.334 15.0884 14.6618 15.6719 15.2452C16.2553 15.8287 16.5831 16.62 16.5831 17.4451V19.0006",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3611 5.10156C18.0303 5.27291 18.6234 5.66211 19.047 6.2078C19.4706 6.7535 19.7005 7.42465 19.7005 8.11545C19.7005 8.80625 19.4706 9.4774 19.047 10.0231C18.6234 10.5688 18.0303 10.958 17.3611 11.1293",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2498 19.0012V17.4456C21.2459 16.759 21.0149 16.0929 20.5928 15.5513C20.1708 15.0096 19.5814 14.6228 18.9165 14.4512",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63867 5.10156C5.96946 5.27291 5.37631 5.66211 4.95273 6.2078C4.52915 6.7535 4.29924 7.42465 4.29924 8.11545C4.29924 8.80625 4.52915 9.4774 4.95273 10.0231C5.37631 10.5688 5.96946 10.958 6.63867 11.1293",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.74992 19.0012V17.4456C2.75387 16.759 2.98487 16.0929 3.40693 15.5513C3.82899 15.0096 4.41839 14.6228 5.08325 14.4512",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleType);
export default __webpack_public_path__ + "static/media/vehicleType.3e73046b820bfabe046763757ae6f9bd.svg";
export { ForwardRef as ReactComponent };